var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',_vm._l((_vm.data.steps[_vm.$route.query.step - 1].sections),function(i,k){return _c('v-card',{key:i.id,staticClass:"mt-6 rounded-xl px-10 pt-6 pb-10",attrs:{"flat":""}},[_c('DocumentItem',{attrs:{"i":i,"k":k}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }